import { createSelector, createSlice } from '@reduxjs/toolkit';

import {
	loadFromSessionStorage,
	loadFromStorage,
	lsKeys,
	saveToSessionStorage,
	saveToStorage,
	ssKeys,
} from '~features/storage';

import type { RootState } from '../index';

type SafeModeModalState = {
	shownForDemo: boolean;
	shownForRegistered: boolean;
};

const initialState = (): SafeModeModalState => {
	const shownForDemo = loadFromSessionStorage(
		ssKeys.NSFW_MODAL_SHOWN_FOR_DEMO,
		false
	);
	const shownForRegistered = loadFromStorage(
		lsKeys.NSFW_MODAL_SHOWN_FOR_REGISTERED,
		false,
		true
	);

	return {
		shownForDemo,
		shownForRegistered,
	};
};

const safeModeModalSlice = createSlice({
	name: 'safeModeModal',
	initialState,
	reducers: {
		showForDemo: (state) => {
			state.shownForDemo = true;
			saveToSessionStorage(ssKeys.NSFW_MODAL_SHOWN_FOR_DEMO, true);
		},
		showForRegistered: (state) => {
			state.shownForRegistered = true;
			saveToStorage(lsKeys.NSFW_MODAL_SHOWN_FOR_REGISTERED, true, true);
		},
	},
});

const safeModeModal = (state: RootState) => state.safeModeModal;

export const getIsModalShownForRegistered = createSelector(
	safeModeModal,
	(state) => state.shownForRegistered
);

export const getIsModalShownForDemo = createSelector(
	safeModeModal,
	(state) => state.shownForDemo
);

export const safeModeModalActions = safeModeModalSlice.actions;

export default safeModeModalSlice.reducer;
